<div class="spinner">
    <div class="sk-rotating-plane"></div>
</div>